document.addEventListener("DOMContentLoaded", function () {
  class SearchButton extends HTMLElement {
    #popinId = "POPIN-search";
    #formId = "FORM-search";
    #popinNS = "c-search-popin";
    #formNS = "c-search-form";
    #boundHandleChange;
    #boundHandleSearch;
    #boundHandleToggle;
    #instance = null;
    constructor() {
      super();
      this.#fallback();
      this.elPopin = document.getElementById(this.#popinId);
      this.elForm = document.getElementById(this.#formId);
      if (this.elPopin === null || this.elForm === null) {
        this.disabled = true;
        return;
      }
      this.elMain = this.elPopin.querySelector(`.${this.#popinNS}__main`);
      this.elResults = this.elPopin.querySelector(`.${this.#popinNS}__results`);
      this.elSearchInput = this.elForm.querySelector(`.${this.#formNS}__field`);
      this.#boundHandleChange = this.#handleChange.bind(this);
      this.#boundHandleSearch = this.#handleSearch.bind(this);
      this.#boundHandleToggle = this.#handleToggle.bind(this);
      this.#instance.addEventListener("click", this.#boundHandleToggle);
      this.elForm.addEventListener("submit", this.#boundHandleSearch);
      this.elSearchInput.addEventListener("input", this.#boundHandleChange);
      this.#checkContent();
    }

    // Thank you Safari, for not supporting the 'is' attribute
    #fallback() {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "s-header__search";
      button.textContent = this.textContent || "Rechercher";
      this.replaceWith(button);
      this.#instance = button;
    }
    #handleToggle(event) {
      event.preventDefault();
      if (this.elPopin.hasAttribute("hidden")) {
        this.#showPopin();
      } else {
        this.#hidePopin();
      }
    }
    #showPopin() {
      document.querySelector('body')?.classList.remove('is-with-menu');
      this.elPopin.removeAttribute("hidden");
      this.elPopin.removeAttribute("tabindex");
    }
    #hidePopin() {
      this.elPopin.setAttribute("hidden", true);
      this.elPopin.setAttribute("tabindex", "-1");
    }
    #checkContent(searchResults = null) {
      if (!searchResults) {
        this.elMain.style.display = "none";
      } else {
        this.elMain.removeAttribute("style");
      }
    }
    async #handleSearch(event) {
      event.preventDefault();
      const formAction = this.elForm.getAttribute("action");
      const formData = new FormData(this.elForm);
      if (formData.get("s") === "") return;
      const requestBody = new URLSearchParams(formData);
      const response = await fetch(formAction, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Cache-Control": "no-cache"
        },
        body: requestBody
      });
      const responseBody = await response.json();
      if (!responseBody.success) {
        alert(responseBody.statusText);
        return;
      }
      const searchResults = responseBody.data;
      this.elResults.innerHTML = searchResults;
      this.#checkContent(searchResults);
    }
    #handleChange() {
      if (this.elSearchInput.value === "") {
        this.#checkContent();
      }
    }
  }
  customElements.define("search-button", SearchButton);
});